import * as React from "react";
const CheckDoubleFillIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#check-double-fill_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m11.602 13.76 1.412 1.412 8.466-8.466 1.414 1.414-9.88 9.88-6.364-6.364 1.414-1.414 2.125 2.125 1.413 1.412Zm.002-2.829 4.952-4.952 1.41 1.41-4.952 4.952-1.41-1.41Zm-2.827 5.656L7.364 18 1 11.636l1.414-1.414 1.413 1.412-.001.002 4.951 4.95Z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "check-double-fill_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}))));
export default CheckDoubleFillIcon;